import type { AnyRouter } from "@tanstack/react-router";

/**
 * SERV-3232: a pick reopens the list on screen in the new entity. Each list reads its search,
 * page, sort and filters from the URL only when it mounts, so the pick clears them from the URL
 * before the list remounts under the new entity; otherwise the filter typed for one entity is
 * applied to the next. These are the params a list needs to keep showing the same tab or drawer.
 */
const LIST_PARAMS_KEPT_ON_PICK: Record<string, readonly string[]> = {
  "/work-orders": ["tab"],
  "/proposals": [],
  "/procurement": ["tab"],
  "/accounts-payable": ["tab", "requestId"],
  "/close-out": [],
  "/accounts-receivable": ["tab"],
  "/check-in-out": ["tab"],
};

export function listSearchAfterPick(
  pathname: string,
  search: Record<string, unknown>,
): Record<string, unknown> | null {
  const kept = LIST_PARAMS_KEPT_ON_PICK[pathname.replace(/\/+$/, "") || "/"];
  if (!kept) return null;

  const present = Object.entries(search).filter(([, value]) => value !== undefined);
  if (present.every(([key]) => kept.includes(key))) return null;

  return Object.fromEntries(present.filter(([key]) => kept.includes(key)));
}

export function clearListSearchForPick(router: AnyRouter | null): Promise<void> | null {
  if (!router) return null;

  const { pathname, search } = router.state.location;
  const nextSearch = listSearchAfterPick(pathname, search as Record<string, unknown>);
  if (!nextSearch) return null;

  return router.navigate({ to: pathname, search: nextSearch, replace: true });
}
